import React from 'react';
import { Phone, MapPin, Navigation } from 'lucide-react';
import { bakeryInfo } from '../data/mock';

export const ContactSection = () => {
  const handleRouteClick = () => {
    // Try to get user's location for directions
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const destination = encodeURIComponent(bakeryInfo.address);
          window.open(
            `https://www.google.com/maps/dir/${latitude},${longitude}/${destination}`,
            '_blank'
          );
        },
        () => {
          const destination = encodeURIComponent(bakeryInfo.address);
          window.open(
            `https://www.google.com/maps/dir//${destination}`,
            '_blank'
          );
        }
      );
    } else {
      const destination = encodeURIComponent(bakeryInfo.address);
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${destination}`,
        '_blank'
      );
    }
  };

  return (
    <section id="kontakt" className="py-16 sm:py-24 lg:py-32 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-16 items-center">
          {/* Content Side */}
          <div>
            <span className="inline-block text-[#61525a] font-medium text-xs sm:text-sm tracking-wider uppercase mb-3 sm:mb-4">
              Kontakt
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e1919] mb-4 sm:mb-6 leading-tight">
              Besuchen Sie uns<br />
              <span className="text-[#61525a]">in Wien</span>
            </h2>
            <p className="text-[#736c64] text-base sm:text-lg leading-relaxed mb-6 sm:mb-10">
              Wir freuen uns, Sie persönlich in unserer Backstube begrüßen zu dürfen. 
              Bei Fragen zu Bestellungen, Catering oder Spezialtorten rufen Sie uns 
              einfach an!
            </p>

            {/* Contact Cards */}
            <div className="space-y-3 sm:space-y-4">
              {/* Phone Card */}
              <a
                href={`tel:${bakeryInfo.phone}`}
                className="group flex items-center gap-4 sm:gap-6 bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <div className="w-12 sm:w-16 h-12 sm:h-16 bg-[#61525a] rounded-lg sm:rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 flex-shrink-0">
                  <Phone className="w-5 sm:w-7 h-5 sm:h-7 text-white" />
                </div>
                <div>
                  <p className="text-xs sm:text-sm text-[#736c64] mb-0.5 sm:mb-1">Jetzt anrufen</p>
                  <p className="text-xl sm:text-2xl font-bold text-[#1e1919] group-hover:text-[#61525a] transition-colors duration-300">
                    {bakeryInfo.phone}
                  </p>
                </div>
              </a>

              {/* Address Card */}
              <a
                href="https://maps.app.goo.gl/spTRAUnRWC8BRPht8"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 sm:gap-6 bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <div className="w-12 sm:w-16 h-12 sm:h-16 bg-[#fad24b] rounded-lg sm:rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 flex-shrink-0">
                  <MapPin className="w-5 sm:w-7 h-5 sm:h-7 text-[#1e1919]" />
                </div>
                <div>
                  <p className="text-xs sm:text-sm text-[#736c64] mb-0.5 sm:mb-1">Adresse</p>
                  <p className="text-lg sm:text-xl font-bold text-[#1e1919] group-hover:text-[#61525a] transition-colors duration-300">
                    {bakeryInfo.address}
                  </p>
                </div>
              </a>
            </div>

            {/* CTA Buttons - Hidden on mobile (MobileBottomBar handles this) */}
            <div className="hidden sm:flex flex-col sm:flex-row gap-3 sm:gap-4 mt-6 sm:mt-8">
              <a
                href={`tel:${bakeryInfo.phone}`}
                className="inline-flex items-center justify-center gap-2 bg-[#61525a] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all duration-300 hover:bg-[#4a3f45] hover:shadow-lg hover:-translate-y-0.5"
              >
                <Phone className="w-4 sm:w-5 h-4 sm:h-5" />
                Jetzt anrufen
              </a>
              <button
                onClick={handleRouteClick}
                className="inline-flex items-center justify-center gap-2 bg-[#fad24b] text-[#1e1919] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all duration-300 hover:bg-[#e5c043] hover:shadow-lg hover:-translate-y-0.5"
              >
                <Navigation className="w-4 sm:w-5 h-4 sm:h-5" />
                Route berechnen
              </button>
            </div>
          </div>

          {/* Map Side */}
          <div className="relative">
            <div className="rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl sm:shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2659.5!2d16.3222248!3d48.1963971!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476da802107d29e3%3A0x46257dd71e130801!2sCafe%20Konditorei%20Rieppel!5e0!3m2!1sde!2sat!4v1"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Standort Cafe Konditorei Rieppel"
                className="grayscale-[30%] contrast-[1.1] sm:h-[450px]"
              />
            </div>

            {/* Decorative Elements - Hidden on mobile */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-[#fad24b]/30 rounded-full blur-2xl hidden sm:block" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#61525a]/20 rounded-full blur-2xl hidden sm:block" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
